/**
 * SECTION 4B JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise SECTION 4B UI, data
         * UI interaction functions
         */
        console.log( 'SECTION 4B  - init' );
        
        this.aon_section_4b_data = [];

        // Get any existing saved data...
        //this.loadData( 'start' );
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            this.loadData( 'load_final_profit_loss' );
            
        } else { // If not Business Plan page then we are in 4B...
            if ( $( '#section_4b_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
        }
        
        
        // Get 4A Overheads data...
        this.load4AOverheadsData();
        
        // Render Data...
        this.renderData();

        
        // Get monthly income value... INCOME
        $( 'body' ).on( 'keyup', '#s4_b_cashflow_form_step_1_money_in_each_year', function( event ) {
            var input = 0;
            if ( $( this ).val() != '' ) {
                var input = $( this ).val();
            }
            //var yearly = parseInt( input, 10);
            var yearly = input * 1;
            var monthly = (yearly / 12);
            $( '#s4_b_cashflow_form_step_1_monthly_income ' ).val( parseFloat( monthly ).toFixed( 2 ) );
            
            $( '#s4_b_profit_loss_account_table_a .income_total' ).text( yearly );
            calculateInitialProfitLossTotal();
            calculateFinalProfitLossFields();
            
            setMonthlyIncomeTableValues( monthly, yearly );
            
            if ( $( this ).val() != '' ) {
                $( '.monthly_income_step1_next' ).removeClass( 'disabled' );
            } else {
                $( '.monthly_income_step1_next' ).addClass( 'disabled' );
            }
            
            console.log( 'S4B: Get monthly income: ' + monthly.toFixed( 2 ) );
            event.preventDefault();
        });
        
        var setMonthlyIncomeTableValues = ( monthly, yearly ) => {
            $( '#s4_b_table_monthly_income input' ).val( monthly.toFixed( 2 ) );
            $( '#s4_b_table_monthly_income_total' ).text( yearly );
            this.saveAnnualMonthlyIncome( yearly, monthly );
        }
        
        
        // Get monthly materials cost... EXPENDITURE - DIRECT COSTS
        $( 'body' ).on( 'keyup', '#s4_b_cashflow_form_step_2_spend_materials_year', function( event ) {
            var input = 0;
            if ( $( this ).val() != '' ) {
                var input = $( this ).val();
            }
            //var yearly = parseInt( input, 10);
            var yearly = input * 1;
            var monthly = parseFloat( yearly / 12 ).toFixed( 2 );
            $( '#s4_b_cashflow_form_step_2_monthly_cost ' ).val( parseFloat( monthly ) );
            
            $( '#s4_b_profit_loss_account_table_a .expenditure_dc_total' ).text( yearly );
            calculateInitialProfitLossTotal();
            calculateFinalProfitLossFields();
            
            setMonthlyMaterialsProductionValues( monthly, yearly );
            
            if ( $( this ).val() != '' ) {
                $( '.materials_production_step2_next' ).removeClass( 'disabled' );
            } else {
                $( '.materials_production_step2_next' ).addClass( 'disabled' );
            }
            
            console.log( 'S4B: Get monthly materials costs: ' + monthly );
            event.preventDefault();
        });
        
        var setMonthlyMaterialsProductionValues = ( monthly, yearly ) => {
            $( '#s4_b_table_monthly_materials_production input' ).val( monthly );
            $( '#s4_b_table_monthly_materials_production_total' ).text( yearly );
            this.saveAnnualMonthlyMaterialsProduction( yearly, monthly );
        }
        
        //
        // 12 MONTH STEP TABLE
        //
        // Set month classes on TH elements in THEAD...
        $( '#s4_b_table_monthly_overheads thead tr' ).each( function( index ) {
            $( 'th', this ).each( function( index ) {
                $( this ).addClass( 'month_column month_' + ( index + 1 ) );
                $( 'input', this ).addClass( 'month_' + ( index + 1 ) );
                $( this ).hide();
            });
            $( '.month_1', this ).show();
        });
        
        // Set month classes on TD elements in TBODY...
        $( '#s4_b_table_monthly_overheads tbody tr' ).each( function( index ) {
            $( 'td', this ).each( function( index ) {
                $( this ).addClass( 'month_column month_' + ( index + 1 ) );
                $( 'input', this ).addClass( 'month_' + ( index + 1 ) );
                $( this ).hide();
            });
            $( '.month_1', this ).show();
        });
        
        var active_step_table_month = 1;
        
        $( 'body' ).on( 'click', '.month-next', function( event ) {
            console.log( 'month-next - active_step_table_month: ' + active_step_table_month );
            setActiveStepTableMonth( 'next' );
        });
        
        $( 'body' ).on( 'click', '.month-previous', function( event ) {
            console.log( 'month-previous - active_step_table_month: ' + active_step_table_month );
            setActiveStepTableMonth( 'previous' );
        });
        
        var setActiveStepTableMonth = ( direction ) => {
            var table = 's4_b_table_monthly_overheads'; // Table ID but without the #
            if ( direction == 'next' ) {
                if ( active_step_table_month < 12 ) {
                    active_step_table_month++;
                    $( '#' + table + ' .month_column' ).hide().removeClass( 'pulse' );
                    $( '#' + table + ' .month_' + active_step_table_month ).show().addClass( 'pulse' );
                }
            } else if ( direction == 'previous' ) {
                if ( active_step_table_month > 1 ) {
                    active_step_table_month--;
                    $( '#' + table + ' .month_column' ).hide().removeClass( 'pulse' );
                    $( '#' + table + ' .month_' + active_step_table_month ).show().addClass( 'pulse' );
                }
            }
       
            if ( active_step_table_month == 1 ) {
                $( '[data-step-month-table-id="' + table + '"] .month-previous' ).addClass( 'disabled' );
                $( '[data-step-month-table-id="' + table + '"] .month-next' ).removeClass( 'disabled' );
            } else if ( active_step_table_month == 12 ) {
                $( '[data-step-month-table-id="' + table + '"] .month-previous' ).removeClass( 'disabled' );
                $( '[data-step-month-table-id="' + table + '"] .month-next' ).addClass( 'disabled' );
            } else {
                $( '[data-step-month-table-id="' + table + '"] .month-previous' ).removeClass( 'disabled' );
                $( '[data-step-month-table-id="' + table + '"] .month-next' ).removeClass( 'disabled' );
            }
        }
        
       /*
        * Calculate Updated Monthly Overheads Fields...
        */
        // Trigger by Keyup on table inputs...
        $( 'body' ).on( 'keyup', '#s4_b_table_monthly_overheads input', function( event ) {
            var month_class = $( this ).attr( 'class' );
            calculateMonthlyOverheads( month_class );
            //event.preventDefault();
        });
        // Trigger by Click on Next button
        $( 'body' ).on( 'click', '.monthly_overheads_table_next', function( event ) {
            calculateMonthlyOverheads( 'month_1' );
            calculateMonthlyOverheads( 'month_2' );
            calculateMonthlyOverheads( 'month_3' );
            calculateMonthlyOverheads( 'month_4' );
            calculateMonthlyOverheads( 'month_5' );
            calculateMonthlyOverheads( 'month_6' );
            calculateMonthlyOverheads( 'month_7' );
            calculateMonthlyOverheads( 'month_8' );
            calculateMonthlyOverheads( 'month_9' );
            calculateMonthlyOverheads( 'month_10' );
            calculateMonthlyOverheads( 'month_11' );
            calculateMonthlyOverheads( 'month_12' );
            event.preventDefault();
        });
        
        var calculateMonthlyOverheads = ( month_class ) => {
            //var month_class = $( this ).attr( 'class' );
            var month = month_class.replace( 'numeric_only ', '' ).replace( ' pulse', '' );
            console.log( 'month: ' + month );
            
            var total = 0;
            $( '#s4_b_table_monthly_overheads input.' + month ).each( function( index ) {
                var month_num = parseFloat( $( this ).val() ); // Value of field
                //total = ( total + month_num ).toFixed( 2 );
                total = ( total + ( month_num * 1 ) );
                
                var field = $( this ).parents( 'tr' ).attr( 'class' ).replace( 's4_b_table_monthly_overheads_form_', '' );
                setMonthlyOverheadsTotal( field, month, month_num, total );
            });
            
            $( '#s4_b_table_monthly_overheads .' + month + ' .s4_b_table_monthly_overheads_total' ).text( parseFloat( total ).toFixed( 2 ) );
          
            calculateFinalProfitLossFields();
        }
        
        var setMonthlyOverheadsTotal = ( field, month, value, total ) => {
            this.saveMonthlyOverheadsTotal( field, month, value, total );
        }
        
        
        // Get monthly salary... EXPENDITURE - OVERHEADS
        $( 'body' ).on( 'keyup', '#s4_b_cashflow_form_step_4_salary_each_year', function( event ) {
            var input = 0;
            if ( $( this ).val() != '' ) {
                var input = $( this ).val();
            }
            var yearly = parseInt( input, 10);
            var monthly = (yearly / 12).toFixed(2);
            $( '#s4_b_cashflow_form_step_4_avg_monthly_salary ' ).val( monthly );
            
            //var monthly_overheads = parseInt( $( '#s4_a_monthly_overheads_form_total' ).text(), 10);
            var yearly_overheads = parseInt( $( '#s4_a_annual_overheads_form_total' ).text(), 10);
            console.log( 'yearly: ' + yearly );
            console.log( 'yearly_overheads: ' + yearly_overheads );
            var combined_overheads = ( parseFloat( yearly_overheads ) + parseFloat( yearly ) ).toFixed(2);
            console.log( 'combined_overheads: ' + combined_overheads );
            
            $( '#s4_b_profit_loss_account_table_a .expenditure_o_total' ).text( combined_overheads );
            calculateInitialProfitLossTotal();
            calculateFinalProfitLossFields();
            
            setMonthlySalaryValues( yearly, monthly );
            
            if ( $( this ).val() != '' ) {
                $( '.salary_step4_next' ).removeClass( 'disabled' );
            } else {
                $( '.salary_step4_next' ).addClass( 'disabled' );
            }
            
            console.log( 'S4B: Get monthly salary: ' + monthly );
            event.preventDefault();
        });
        
        var setMonthlySalaryValues = ( yearly, monthly ) => {
            this.saveAnnualMonthlySalary( yearly, monthly );
        }
        
       /*
        * Monthly Income Fields...
        */
        // Trigger by Keyup on table inputs...
        $( 'body' ).on( 'keyup', '#s4_b_table_monthly_income input', function( event ) {
            calculateMonthlyIncomeFields();
        });
        // Trigger by Click on Next button
        $( 'body' ).on( 'click', '.monthly_income_table_next', function( event ) {
            calculateMonthlyIncomeFields();
            event.preventDefault();
        });
        
        var calculateMonthlyIncomeFields = () => {
            // Add all the fields up...
            var total = 0;
            $( '#s4_b_table_monthly_income input.numeric_only' ).each( function() {
                var input = 0;
                if ( $( this ).val() != '' ) {
                    //var input = parseFloat( $( this ).val() ).toFixed( 2 );
                    var input = parseFloat( $( this ).val() );
                }
                total = total + ( input * 1 );
                //total + $( this ).val() * 1;
                console.log( ' - ' + input );
                
                var field = $( this ).attr( 'id' ).replace( 's4_b_table_', '' );
                setIndividualMonthlyIncome( field, input, total );
                
            });
            $( '#s4_b_table_monthly_income_total' ).text( parseFloat( total ).toFixed( 2 ) );
            
            calculateFinalProfitLossFields();
        }
        
        var setIndividualMonthlyIncome = ( field, input, total ) => {
            console.log( 'setIndividualMonthlyIncome: ' + field + ' - ' + input + ' - ' + total );
            this.saveIndividualMonthlyIncome( field, input, total );
        }
        
        
        
       /*
        * Monthly Materials & Production Fields...
        */
        // Trigger by Keyup on table inputs...
        $( 'body' ).on( 'keyup', '#s4_b_table_monthly_materials_production input', function( event ) {
            calculateMonthlyMaterialsProductionFields();
        });
        // Trigger by Click on Next button
        $( 'body' ).on( 'click', '.monthly_materials_production_table_next', function( event ) {
            calculateMonthlyMaterialsProductionFields();
        });
        
        var calculateMonthlyMaterialsProductionFields = () => {
            // Add all the fields up...
            var total = 0;
            $( '#s4_b_table_monthly_materials_production input.numeric_only' ).each( function() {
                var input = 0;
                if ( $( this ).val() != '' ) {
                    var input = parseFloat( $( this ).val() );
                }
                total = total + ( input * 1 );
                console.log( ' - ' + input );
                
                var field = $( this ).attr( 'id' ).replace( 's4_b_table_', '' );
                setIndividualMaterialsProduction( field, input, total );
                
            });
            $( '#s4_b_table_monthly_materials_production_total' ).text( parseFloat( total ).toFixed( 2 ) );
            
            calculateFinalProfitLossFields();
        }
        
        var setIndividualMaterialsProduction = ( field, input, total ) => {
            this.saveIndividualMaterialsProduction( field, input, total );
        }
        
        var calculateInitialProfitLossTotal = () => {
            var income_total = parseFloat( $( '#s4_b_profit_loss_account_table_a .income_total' ).text() ).toFixed(2);
            var expenditure_dc_total = parseFloat( $( '#s4_b_profit_loss_account_table_a .expenditure_dc_total' ).text() ).toFixed(2);
            var expenditure_o_total = parseFloat( $( '#s4_b_profit_loss_account_table_a .expenditure_o_total' ).text() ).toFixed(2);
            var cashflow_balance_total = parseFloat( income_total ) - parseFloat( expenditure_dc_total ) - parseFloat( expenditure_o_total );
            $( '#s4_b_profit_loss_account_table_a .cashflow_balance_total' ).text( parseFloat( cashflow_balance_total ).toFixed(2) );
            
            this.saveInitialProfitLoss( income_total, expenditure_dc_total, expenditure_o_total, cashflow_balance_total );
        }
        
        var calculateFinalProfitLossTotal = () => {
            var income_total = parseFloat( $( '#s4_b_profit_loss_account_table_b .income_total' ).text() ).toFixed(2);
            var expenditure_dc_total = parseFloat( $( '#s4_b_profit_loss_account_table_b .expenditure_dc_total' ).text() ).toFixed(2);
            var expenditure_o_total = parseFloat( $( '#s4_b_profit_loss_account_table_b .expenditure_o_total' ).text() ).toFixed(2);
            var cashflow_balance_total = ( parseFloat( income_total ) - parseFloat( expenditure_dc_total ) - parseFloat( expenditure_o_total ) ).toFixed(2);
            $( '#s4_b_profit_loss_account_table_b .cashflow_balance_total' ).text( cashflow_balance_total );
            
            this.saveFinalProfitLoss( income_total, expenditure_dc_total, expenditure_o_total, cashflow_balance_total );
            
        }        
        
        var calculateFinalProfitLossFields = () => {
            //Final monthly income total for 12 months:
            var yearly_income = $( '#s4_b_table_monthly_income_total' ).text();
            $( '#s4_b_profit_loss_account_table_b .income_total' ).text( yearly_income );

            //Final monthly materials & production total for 12 months:
            var yearly_mat_prod = $( '#s4_b_table_monthly_materials_production_total' ).text();
            $( '#s4_b_profit_loss_account_table_b .expenditure_dc_total' ).text( yearly_mat_prod );

            //var combined_overheads = yearly overheads + yearly salary
            //Final Yearly Overheads - add together the following:
            var a = parseFloat( $( '.month_1 .s4_b_table_monthly_overheads_total' ).text() );
            var b = parseFloat( $( '.month_2 .s4_b_table_monthly_overheads_total' ).text() );
            var c = parseFloat( $( '.month_3 .s4_b_table_monthly_overheads_total' ).text() );
            var d = parseFloat( $( '.month_4 .s4_b_table_monthly_overheads_total' ).text() );
            var e = parseFloat( $( '.month_5 .s4_b_table_monthly_overheads_total' ).text() );
            var f = parseFloat( $( '.month_6 .s4_b_table_monthly_overheads_total' ).text() );
            var g = parseFloat( $( '.month_7 .s4_b_table_monthly_overheads_total' ).text() );
            var h = parseFloat( $( '.month_8 .s4_b_table_monthly_overheads_total' ).text() );
            var i = parseFloat( $( '.month_9 .s4_b_table_monthly_overheads_total' ).text() );
            var j = parseFloat( $( '.month_10 .s4_b_table_monthly_overheads_total' ).text() );
            var k = parseFloat( $( '.month_11 .s4_b_table_monthly_overheads_total' ).text() );
            var l = parseFloat( $( '.month_12 .s4_b_table_monthly_overheads_total' ).text() );
            // and
            //Yearly Salary total:
            var yearly_salary = parseFloat( $( '#s4_b_cashflow_form_step_4_salary_each_year' ).val() );
            
            var combined_overheads = a + b + c + d + e + f + g + h + i + j + k + l + yearly_salary;
            
            $( '#s4_b_profit_loss_account_table_b .expenditure_o_total' ).text( combined_overheads );
            
            calculateFinalProfitLossTotal();
        }
        
        
        
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });
        

    },
    
    loadFinalProfitLoss() {
        this.loadData( 'load_final_profit_loss' );
    },
    
    renderData() {
        console.log( 'renderData - Section 4B');
    
        // Loop over entries array...
        var entry_count = 1;
        $.each( this.aon_section_4b_data, function( index ) {
            // Loop over data entries...   
            //$( '#s4_b_field_1' ).val( this.s4_b_field_1 );
            //$( '#s4_b_field_2' ).val( this.s4_b_field_2 );

            entry_count++;
            
        });
        console.log( 'rendering...' );
        
    },
    
    saveAnnualMonthlyIncome( yearly, monthly ) {
        this.aon_section_4b_data[ 0 ][ 'annual_income' ] = Number( yearly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_january' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_february' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_march' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_april' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_may' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_june' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_july' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_august' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_september' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_october' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_november' ] = Number( monthly );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_december' ] = Number( monthly );
            
        console.log( 'SAVE ANNUAL / MONTHLY INCOME' );
        console.table( this.aon_section_4b_data );
    },
    
    saveAnnualMonthlyMaterialsProduction( yearly, monthly ) {
        this.aon_section_4b_data[ 0 ][ 'annual_spend' ] = Number( yearly );
        this.aon_section_4b_data[ 0 ][ 'monthly_spend' ] = Number( monthly );
        console.log( 'SAVE ANNUAL / MONTHLY MATERIALS & PRODUCTION' );
        console.table( this.aon_section_4b_data );
    },
    
    saveAnnualMonthlySalary( yearly, monthly ) {
        this.aon_section_4b_data[ 0 ][ 'annual_salary' ] = Number( yearly );
        this.aon_section_4b_data[ 0 ][ 'monthly_salary' ] = Number( monthly );
        console.log( 'SAVE ANNUAL / MONTHLY MATERIALS & PRODUCTION' );
        console.table( this.aon_section_4b_data );
    },
    
    saveInitialProfitLoss( income_total, expenditure_dc_total, expenditure_o_total, cashflow_balance_total ) {
        this.aon_section_4b_data[ 0 ][ 'profit_loss_income_initial' ] = Number( income_total );
        this.aon_section_4b_data[ 0 ][ 'profit_loss_exp_direct_costs_initial' ] = Number( expenditure_dc_total );
        this.aon_section_4b_data[ 0 ][ 'profit_loss_exp_overheads_initial' ] = Number( expenditure_o_total );
        this.aon_section_4b_data[ 0 ][ 'profit_loss_cashflow_balance_initial' ] = Number( cashflow_balance_total );
        console.log( 'SAVE INITIAL PROFIT & LOSS' );
        console.table( this.aon_section_4b_data );
    },
    
    saveFinalProfitLoss( income_total, expenditure_dc_total, expenditure_o_total, cashflow_balance_total ) {
        this.aon_section_4b_data[ 0 ][ 'profit_loss_income_final' ] = Number( income_total );
        this.aon_section_4b_data[ 0 ][ 'profit_loss_exp_direct_costs_final' ] = Number( expenditure_dc_total );
        this.aon_section_4b_data[ 0 ][ 'profit_loss_exp_overheads_final' ] = Number( expenditure_o_total );
        this.aon_section_4b_data[ 0 ][ 'profit_loss_cashflow_balance_final' ] = Number( cashflow_balance_total );
        console.log( 'SAVE FINAL PROFIT & LOSS' );
        console.table( this.aon_section_4b_data );
    },
    
    saveIndividualMonthlyIncome( field, value, total ) {
        this.aon_section_4b_data[ 0 ][ field ] = Number( value );
        this.aon_section_4b_data[ 0 ][ 'monthly_income_total' ] = Number( total );
        console.log( 'SAVE INDIVIDUAL MONTHLY INCOME: ' + field + ' - ' + value + ' - Total: ' + Number( total ).toFixed(2) );
        console.table( this.aon_section_4b_data );
    },
    
    saveIndividualMaterialsProduction( field, value, total ) {
        this.aon_section_4b_data[ 0 ][ field ] = Number( value );
        this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_total' ] = Number( total );
        console.log( 'SAVE INDIVIDUAL MONTHLY SPEND (MATERIALS / PRODUCTION): ' + field + ' - ' + value + ' - Total: ' + Number( total ).toFixed(2) );
        console.table( this.aon_section_4b_data );
    },
    
    saveMonthlyOverheadsTotal( field, month, value, total ) {
        var field_ref = '';
        if ( month == 'month_1' ) {
            field_ref = 'monthly_overheads_january_';
        } else if ( month == 'month_2' ) {
            field_ref = 'monthly_overheads_february_';
        } else if ( month == 'month_3' ) {
            field_ref = 'monthly_overheads_march_';
        } else if ( month == 'month_4' ) {
            field_ref = 'monthly_overheads_april_';
        } else if ( month == 'month_5' ) {
            field_ref = 'monthly_overheads_may_';
        } else if ( month == 'month_6' ) {
            field_ref = 'monthly_overheads_june_';
        } else if ( month == 'month_7' ) {
            field_ref = 'monthly_overheads_july_';
        } else if ( month == 'month_8' ) {
            field_ref = 'monthly_overheads_august_';
        } else if ( month == 'month_9' ) {
            field_ref = 'monthly_overheads_september_';
        } else if ( month == 'month_10' ) {
            field_ref = 'monthly_overheads_october_';
        } else if ( month == 'month_11' ) {
            field_ref = 'monthly_overheads_november_';
        } else if ( month == 'month_12' ) {
            field_ref = 'monthly_overheads_december_';
        }
        console.log( 'field_ref + field: ' + field_ref + field );
        this.aon_section_4b_data[ 0 ][ field_ref + field ] = Number( value );
        console.log( 'saveMonthlyOverheadsTotal: .' + month + ' .s4_b_table_monthly_overheads_total: ' + total );
        
        this.aon_section_4b_data[ 0 ][ field_ref + 'total' ] = Number( total );
        //this.aon_section_4b_data[ 0 ][ '.' + month + ' .s4_b_table_monthly_overheads_total' ] = Number( total );
        console.log( field_ref + 'total: ' + this.aon_section_4b_data[ 0 ][ field_ref + 'total' ] );
    },
    
    addDataEntry() {
        // Default variables for data structure...
        var annual_income = 0;
        var monthly_income = 0;
        var annual_spend = 0;
        var monthly_spend = 0;
        var annual_salary = 0;
        var monthly_salary = 0;
        
        var profit_loss_income_initial = 0;
        var profit_loss_exp_direct_costs_initial = 0;
        var profit_loss_exp_overheads_initial = 0;
        var profit_loss_cashflow_balance_initial = 0;
        
        var monthly_income_january = 0;
        var monthly_income_february = 0;
        var monthly_income_march = 0;
        var monthly_income_april = 0;
        var monthly_income_may = 0;
        var monthly_income_june = 0;
        var monthly_income_july = 0;
        var monthly_income_august = 0;
        var monthly_income_september = 0;
        var monthly_income_october = 0;
        var monthly_income_november = 0;
        var monthly_income_december = 0;
        var monthly_income_total = 0;
        
        var monthly_materials_production_january = 0;
        var monthly_materials_production_february = 0;
        var monthly_materials_production_march = 0;
        var monthly_materials_production_april = 0;
        var monthly_materials_production_may = 0;
        var monthly_materials_production_june = 0;
        var monthly_materials_production_july = 0;
        var monthly_materials_production_august = 0;
        var monthly_materials_production_september = 0;
        var monthly_materials_production_october = 0;
        var monthly_materials_production_november = 0;
        var monthly_materials_production_december = 0;
        var monthly_materials_production_total = 0;
        
        var monthly_overheads_january_rent_etc = 0;
        var monthly_overheads_january_property_etc = 0;
        var monthly_overheads_january_phone_etc = 0;
        var monthly_overheads_january_bank_etc = 0;
        var monthly_overheads_january_car_etc = 0;
        var monthly_overheads_january_accountancy_etc = 0;
        var monthly_overheads_january_wages_etc = 0;
        var monthly_overheads_january_other = 0;
        var monthly_overheads_january_total = 0;
     
        var monthly_overheads_february_rent_etc = 0;
        var monthly_overheads_february_property_etc = 0;
        var monthly_overheads_february_phone_etc = 0;
        var monthly_overheads_february_bank_etc = 0;
        var monthly_overheads_february_car_etc = 0;
        var monthly_overheads_february_accountancy_etc = 0;
        var monthly_overheads_february_wages_etc = 0;
        var monthly_overheads_february_other = 0;
        var monthly_overheads_february_total = 0;
     
        var monthly_overheads_march_rent_etc = 0;
        var monthly_overheads_march_property_etc = 0;
        var monthly_overheads_march_phone_etc = 0;
        var monthly_overheads_march_bank_etc = 0;
        var monthly_overheads_march_car_etc = 0;
        var monthly_overheads_march_accountancy_etc = 0;
        var monthly_overheads_march_wages_etc = 0;
        var monthly_overheads_march_other = 0;
        var monthly_overheads_march_total = 0;
     
        var monthly_overheads_april_rent_etc = 0;
        var monthly_overheads_april_property_etc = 0;
        var monthly_overheads_april_phone_etc = 0;
        var monthly_overheads_april_bank_etc = 0;
        var monthly_overheads_april_car_etc = 0;
        var monthly_overheads_april_accountancy_etc = 0;
        var monthly_overheads_april_wages_etc = 0;
        var monthly_overheads_april_other = 0;
        var monthly_overheads_april_total = 0;
     
        var monthly_overheads_may_rent_etc = 0;
        var monthly_overheads_may_property_etc = 0;
        var monthly_overheads_may_phone_etc = 0;
        var monthly_overheads_may_bank_etc = 0;
        var monthly_overheads_may_car_etc = 0;
        var monthly_overheads_may_accountancy_etc = 0;
        var monthly_overheads_may_wages_etc = 0;
        var monthly_overheads_may_other = 0;
        var monthly_overheads_may_total = 0;
     
        var monthly_overheads_june_rent_etc = 0;
        var monthly_overheads_june_property_etc = 0;
        var monthly_overheads_june_phone_etc = 0;
        var monthly_overheads_june_bank_etc = 0;
        var monthly_overheads_june_car_etc = 0;
        var monthly_overheads_june_accountancy_etc = 0;
        var monthly_overheads_june_wages_etc = 0;
        var monthly_overheads_june_other = 0;
        var monthly_overheads_june_total = 0;
     
        var monthly_overheads_july_rent_etc = 0;
        var monthly_overheads_july_property_etc = 0;
        var monthly_overheads_july_phone_etc = 0;
        var monthly_overheads_july_bank_etc = 0;
        var monthly_overheads_july_car_etc = 0;
        var monthly_overheads_july_accountancy_etc = 0;
        var monthly_overheads_july_wages_etc = 0;
        var monthly_overheads_july_other = 0;
        var monthly_overheads_july_total = 0;
     
        var monthly_overheads_august_rent_etc = 0;
        var monthly_overheads_august_property_etc = 0;
        var monthly_overheads_august_phone_etc = 0;
        var monthly_overheads_august_bank_etc = 0;
        var monthly_overheads_august_car_etc = 0;
        var monthly_overheads_august_accountancy_etc = 0;
        var monthly_overheads_august_wages_etc = 0;
        var monthly_overheads_august_other = 0;
        var monthly_overheads_august_total = 0;
     
        var monthly_overheads_september_rent_etc = 0;
        var monthly_overheads_september_property_etc = 0;
        var monthly_overheads_september_phone_etc = 0;
        var monthly_overheads_september_bank_etc = 0;
        var monthly_overheads_september_car_etc = 0;
        var monthly_overheads_september_accountancy_etc = 0;
        var monthly_overheads_september_wages_etc = 0;
        var monthly_overheads_september_other = 0;
        var monthly_overheads_september_total = 0;
     
        var monthly_overheads_october_rent_etc = 0;
        var monthly_overheads_october_property_etc = 0;
        var monthly_overheads_october_phone_etc = 0;
        var monthly_overheads_october_bank_etc = 0;
        var monthly_overheads_october_car_etc = 0;
        var monthly_overheads_october_accountancy_etc = 0;
        var monthly_overheads_october_wages_etc = 0;
        var monthly_overheads_october_other = 0;
        var monthly_overheads_october_total = 0;
     
        var monthly_overheads_november_rent_etc = 0;
        var monthly_overheads_november_property_etc = 0;
        var monthly_overheads_november_phone_etc = 0;
        var monthly_overheads_november_bank_etc = 0;
        var monthly_overheads_november_car_etc = 0;
        var monthly_overheads_november_accountancy_etc = 0;
        var monthly_overheads_november_wages_etc = 0;
        var monthly_overheads_november_other = 0;
        var monthly_overheads_november_total = 0;
     
        var monthly_overheads_december_rent_etc = 0;
        var monthly_overheads_december_property_etc = 0;
        var monthly_overheads_december_phone_etc = 0;
        var monthly_overheads_december_bank_etc = 0;
        var monthly_overheads_december_car_etc = 0;
        var monthly_overheads_december_accountancy_etc = 0;
        var monthly_overheads_december_wages_etc = 0;
        var monthly_overheads_december_other = 0;
        var monthly_overheads_december_total = 0;
     
        var profit_loss_income_final = 0;
        var profit_loss_exp_direct_costs_final = 0;
        var profit_loss_exp_overheads_final = 0;
        var profit_loss_cashflow_balance_final = 0;
        
        // Push default data to data structure array...
        this.aon_section_4b_data.push( { 
            annual_income,
            monthly_income,
            annual_spend,
            monthly_spend,
            annual_salary,
            monthly_salary,
            
            profit_loss_income_initial,
            profit_loss_exp_direct_costs_initial,
            profit_loss_exp_overheads_initial,
            profit_loss_cashflow_balance_initial,
            
            monthly_income_january,
            monthly_income_february,
            monthly_income_march,
            monthly_income_april,
            monthly_income_may,
            monthly_income_june,
            monthly_income_july,
            monthly_income_august,
            monthly_income_september,
            monthly_income_october,
            monthly_income_november,
            monthly_income_december,
            monthly_income_total,
            
            monthly_materials_production_january,
            monthly_materials_production_february,
            monthly_materials_production_march,
            monthly_materials_production_april,
            monthly_materials_production_may,
            monthly_materials_production_june,
            monthly_materials_production_july,
            monthly_materials_production_august,
            monthly_materials_production_september,
            monthly_materials_production_october,
            monthly_materials_production_november,
            monthly_materials_production_december,
            monthly_materials_production_total,

            monthly_overheads_january_rent_etc,
            monthly_overheads_january_property_etc,
            monthly_overheads_january_phone_etc,
            monthly_overheads_january_bank_etc,
            monthly_overheads_january_car_etc,
            monthly_overheads_january_accountancy_etc,
            monthly_overheads_january_wages_etc,
            monthly_overheads_january_other,
            monthly_overheads_january_total,

            monthly_overheads_february_rent_etc,
            monthly_overheads_february_property_etc,
            monthly_overheads_february_phone_etc,
            monthly_overheads_february_bank_etc,
            monthly_overheads_february_car_etc,
            monthly_overheads_february_accountancy_etc,
            monthly_overheads_february_wages_etc,
            monthly_overheads_february_other,
            monthly_overheads_february_total,

            monthly_overheads_march_rent_etc,
            monthly_overheads_march_property_etc,
            monthly_overheads_march_phone_etc,
            monthly_overheads_march_bank_etc,
            monthly_overheads_march_car_etc,
            monthly_overheads_march_accountancy_etc,
            monthly_overheads_march_wages_etc,
            monthly_overheads_march_other,
            monthly_overheads_march_total,

            monthly_overheads_april_rent_etc,
            monthly_overheads_april_property_etc,
            monthly_overheads_april_phone_etc,
            monthly_overheads_april_bank_etc,
            monthly_overheads_april_car_etc,
            monthly_overheads_april_accountancy_etc,
            monthly_overheads_april_wages_etc,
            monthly_overheads_april_other,
            monthly_overheads_april_total,

            monthly_overheads_may_rent_etc,
            monthly_overheads_may_property_etc,
            monthly_overheads_may_phone_etc,
            monthly_overheads_may_bank_etc,
            monthly_overheads_may_car_etc,
            monthly_overheads_may_accountancy_etc,
            monthly_overheads_may_wages_etc,
            monthly_overheads_may_other,
            monthly_overheads_may_total,

            monthly_overheads_june_rent_etc,
            monthly_overheads_june_property_etc,
            monthly_overheads_june_phone_etc,
            monthly_overheads_june_bank_etc,
            monthly_overheads_june_car_etc,
            monthly_overheads_june_accountancy_etc,
            monthly_overheads_june_wages_etc,
            monthly_overheads_june_other,
            monthly_overheads_june_total,

            monthly_overheads_july_rent_etc,
            monthly_overheads_july_property_etc,
            monthly_overheads_july_phone_etc,
            monthly_overheads_july_bank_etc,
            monthly_overheads_july_car_etc,
            monthly_overheads_july_accountancy_etc,
            monthly_overheads_july_wages_etc,
            monthly_overheads_july_other,
            monthly_overheads_july_total,

            monthly_overheads_august_rent_etc,
            monthly_overheads_august_property_etc,
            monthly_overheads_august_phone_etc,
            monthly_overheads_august_bank_etc,
            monthly_overheads_august_car_etc,
            monthly_overheads_august_accountancy_etc,
            monthly_overheads_august_wages_etc,
            monthly_overheads_august_other,
            monthly_overheads_august_total,

            monthly_overheads_september_rent_etc,
            monthly_overheads_september_property_etc,
            monthly_overheads_september_phone_etc,
            monthly_overheads_september_bank_etc,
            monthly_overheads_september_car_etc,
            monthly_overheads_september_accountancy_etc,
            monthly_overheads_september_wages_etc,
            monthly_overheads_september_other,
            monthly_overheads_september_total,

            monthly_overheads_october_rent_etc,
            monthly_overheads_october_property_etc,
            monthly_overheads_october_phone_etc,
            monthly_overheads_october_bank_etc,
            monthly_overheads_october_car_etc,
            monthly_overheads_october_accountancy_etc,
            monthly_overheads_october_wages_etc,
            monthly_overheads_october_other,
            monthly_overheads_october_total,

            monthly_overheads_november_rent_etc,
            monthly_overheads_november_property_etc,
            monthly_overheads_november_phone_etc,
            monthly_overheads_november_bank_etc,
            monthly_overheads_november_car_etc,
            monthly_overheads_november_accountancy_etc,
            monthly_overheads_november_wages_etc,
            monthly_overheads_november_other,
            monthly_overheads_november_total,

            monthly_overheads_december_rent_etc,
            monthly_overheads_december_property_etc,
            monthly_overheads_december_phone_etc,
            monthly_overheads_december_bank_etc,
            monthly_overheads_december_car_etc,
            monthly_overheads_december_accountancy_etc,
            monthly_overheads_december_wages_etc,
            monthly_overheads_december_other,
            monthly_overheads_december_total,
            
            profit_loss_income_final,
            profit_loss_exp_direct_costs_final,
            profit_loss_exp_overheads_final,
            profit_loss_cashflow_balance_final
            
        } );
        
        console.table( 'addDataEntry: ' + this.aon_section_4b_data );
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        
        
        
        // Load data from backend...
        if ( mode == 'load_final_profit_loss' ) {
            console.log( 'load_final_profit_loss' );
			if ( $( '#section_4b_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
				var aon_section_4b_data_json = $( '#section_4b_data_json' ).val();
				this.aon_section_4b_data = JSON.parse( aon_section_4b_data_json );
				$( '#s4_b_profit_loss_account_table_bplan .income_total' ).text( this.aon_section_4b_data[ 0 ][ 'profit_loss_income_final' ] );
				$( '#s4_b_profit_loss_account_table_bplan .expenditure_dc_total' ).text( this.aon_section_4b_data[ 0 ][ 'profit_loss_exp_direct_costs_final' ] );
				$( '#s4_b_profit_loss_account_table_bplan .expenditure_o_total' ).text( this.aon_section_4b_data[ 0 ][ 'profit_loss_exp_overheads_final' ] );
				$( '#s4_b_profit_loss_account_table_bplan .cashflow_balance_total' ).text( this.aon_section_4b_data[ 0 ][ 'profit_loss_cashflow_balance_final' ] );
			}
          
        } else if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_4b_data_json = $( '#section_4b_data_json' ).val();
            this.aon_section_4b_data = JSON.parse( aon_section_4b_data_json );
            $( '#s4_b_cashflow_form_step_1_money_in_each_year' ).val( this.aon_section_4b_data[ 0 ][ 'annual_income' ] );
            
            if ( this.aon_section_4b_data[ 0 ][ 'annual_income' ] != '' ) { // Check this value is not empty and enable 'Next' button
                $( '.monthly_income_step1_next' ).removeClass( 'disabled' );
            } else {
                $( '.monthly_income_step1_next' ).addClass( 'disabled' );
            }
            
            $( '#s4_b_cashflow_form_step_1_monthly_income' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income' ] );
            $( '#s4_b_cashflow_form_step_2_spend_materials_year' ).val( this.aon_section_4b_data[ 0 ][ 'annual_spend' ] );
            
            if ( this.aon_section_4b_data[ 0 ][ 'annual_spend' ] != '' ) { // Check this value is not empty and enable 'Next' button
                $( '.materials_production_step2_next' ).removeClass( 'disabled' );
            } else {
                $( '.materials_production_step2_next' ).addClass( 'disabled' );
            }
            
            $( '#s4_b_cashflow_form_step_2_monthly_cost' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_spend' ] );
            
            $( '#s4_b_cashflow_form_step_4_salary_each_year' ).val( this.aon_section_4b_data[ 0 ][ 'annual_salary' ] );
            if ( this.aon_section_4b_data[ 0 ][ 'annual_salary' ] != '' ) { // Check this value is not empty and enable 'Next' button
                $( '.salary_step4_next' ).removeClass( 'disabled' );
            } else {
                $( '.salary_step4_next' ).addClass( 'disabled' );
            }
            
            $( '#s4_b_cashflow_form_step_4_avg_monthly_salary' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_salary' ] );
            
            $( '#s4_b_profit_loss_account_table_a .income_total' ).text( this.aon_section_4b_data[ 0 ][ 'profit_loss_income_final' ] );
            $( '#s4_b_profit_loss_account_table_a .expenditure_dc_total' ).text( this.aon_section_4b_data[ 0 ][ 'profit_loss_exp_direct_costs_final' ] );
            $( '#s4_b_profit_loss_account_table_a .expenditure_o_total' ).text( this.aon_section_4b_data[ 0 ][ 'profit_loss_exp_overheads_final' ] );
            $( '#s4_b_profit_loss_account_table_a .cashflow_balance_total' ).text( this.aon_section_4b_data[ 0 ][ 'profit_loss_cashflow_balance_final' ] );
            
            $( '#s4_b_table_monthly_income_january' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_january' ] );
            $( '#s4_b_table_monthly_income_february' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_february' ] );
            $( '#s4_b_table_monthly_income_march' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_march' ] );
            $( '#s4_b_table_monthly_income_april' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_april' ] );
            $( '#s4_b_table_monthly_income_may' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_may' ] );
            $( '#s4_b_table_monthly_income_june' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_june' ] );
            $( '#s4_b_table_monthly_income_july' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_july' ] );
            $( '#s4_b_table_monthly_income_august' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_august' ] );
            $( '#s4_b_table_monthly_income_september' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_september' ] );
            $( '#s4_b_table_monthly_income_october' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_october' ] );
            $( '#s4_b_table_monthly_income_november' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_november' ] );
            $( '#s4_b_table_monthly_income_december' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_income_december' ] );
            $( '#s4_b_table_monthly_income_total' ).text( this.aon_section_4b_data[ 0 ][ 'monthly_income_total' ] );
            
            $( '#s4_b_table_monthly_materials_production_january' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_january' ] );
            $( '#s4_b_table_monthly_materials_production_february' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_february' ] );
            $( '#s4_b_table_monthly_materials_production_march' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_march' ] );
            $( '#s4_b_table_monthly_materials_production_april' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_april' ] );
            $( '#s4_b_table_monthly_materials_production_may' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_may' ] );
            $( '#s4_b_table_monthly_materials_production_june' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_june' ] );
            $( '#s4_b_table_monthly_materials_production_july' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_july' ] );
            $( '#s4_b_table_monthly_materials_production_august' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_august' ] );
            $( '#s4_b_table_monthly_materials_production_september' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_september' ] );
            $( '#s4_b_table_monthly_materials_production_october' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_october' ] );
            $( '#s4_b_table_monthly_materials_production_november' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_november' ] );
            $( '#s4_b_table_monthly_materials_production_december' ).val( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_december' ] );
            $( '#s4_b_table_monthly_materials_production_total' ).text( this.aon_section_4b_data[ 0 ][ 'monthly_materials_production_total' ] );
            
            // We don't need to load any further data fields e.g. monthly breakdowns etc as these get calculated based on the data loaded above
            // We do need to enable some 'Next' buttons though to allow user progress
         

            
        } else if ( mode == 'load_demo' ) {
            
            // Using temp JSON source for now, but this would load from the backend...
            var aon_section_4b_data_json = '[';
                aon_section_4b_data_json += '{';
            
                aon_section_4b_data_json += '"annual_income":"0",';
                aon_section_4b_data_json += '"monthly_income":"0",';
                aon_section_4b_data_json += '"annual_spend":"0",';
                aon_section_4b_data_json += '"monthly_spend":"0",';
                aon_section_4b_data_json += '"annual_salary":"0",';
                aon_section_4b_data_json += '"monthly_salary":"0",';
            
                aon_section_4b_data_json += '"profit_loss_income":"0",';
                aon_section_4b_data_json += '"profit_loss_exp_direct_costs":"0",';
                aon_section_4b_data_json += '"profit_loss_exp_overheads":"0",';
                aon_section_4b_data_json += '"profit_loss_cashflow_balance":"0",';
            
                aon_section_4b_data_json += '"monthly_income_january":"0",';
                aon_section_4b_data_json += '"monthly_income_february":"0",';
                aon_section_4b_data_json += '"monthly_income_march":"0",';
                aon_section_4b_data_json += '"monthly_income_april":"0",';
                aon_section_4b_data_json += '"monthly_income_may":"0",';
                aon_section_4b_data_json += '"monthly_income_june":"0",';
                aon_section_4b_data_json += '"monthly_income_july":"0",';
                aon_section_4b_data_json += '"monthly_income_august":"0",';
                aon_section_4b_data_json += '"monthly_income_september":"0",';
                aon_section_4b_data_json += '"monthly_income_october":"0",';
                aon_section_4b_data_json += '"monthly_income_november":"0",';
                aon_section_4b_data_json += '"monthly_income_december":"0",';
                aon_section_4b_data_json += '"monthly_income_total":"0",';
            
                aon_section_4b_data_json += '"monthly_materials_production_january":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_february":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_march":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_april":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_may":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_june":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_july":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_august":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_september":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_october":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_november":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_december":"0",';
                aon_section_4b_data_json += '"monthly_materials_production_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_january_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_january_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_january_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_january_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_january_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_january_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_january_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_january_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_january_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_february_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_february_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_february_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_february_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_february_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_february_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_february_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_february_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_february_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_march_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_march_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_march_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_march_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_march_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_march_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_march_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_march_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_march_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_april_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_april_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_april_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_april_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_april_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_april_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_april_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_april_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_april_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_may_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_may_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_may_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_may_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_may_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_may_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_may_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_may_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_may_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_june_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_june_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_june_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_june_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_june_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_june_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_june_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_june_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_june_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_july_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_july_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_july_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_july_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_july_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_july_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_july_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_july_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_july_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_august_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_august_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_august_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_august_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_august_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_august_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_august_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_august_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_august_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_september_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_september_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_september_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_september_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_september_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_september_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_september_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_september_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_september_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_october_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_october_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_october_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_october_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_october_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_october_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_october_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_october_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_october_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_november_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_november_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_november_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_november_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_november_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_november_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_november_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_november_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_november_total":"0",';

                aon_section_4b_data_json += '"monthly_overheads_december_rent_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_december_property_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_december_phone_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_december_bank_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_december_car_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_december_accountancy_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_december_wages_etc":"0",';
                aon_section_4b_data_json += '"monthly_overheads_december_other":"0",';
                aon_section_4b_data_json += '"monthly_overheads_december_total":"0",';
            
                aon_section_4b_data_json += '}';
                aon_section_4b_data_json += ']';

            this.aon_section_4b_data = JSON.parse( aon_section_4b_data_json );

        } else if ( mode == 'start' ) {

            this.addDataEntry();
            
        }
        console.table( this.aon_section_4b_data );
        //console.log( 'this.aon_section_4b_data[0][\'annual_income\']: ' + this.aon_section_4b_data[0]['annual_income'] );
  
    },
        
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        // ?? Maybe make this into a single function used by all sections???
        var jsonDataString = JSON.stringify( this.aon_section_4b_data );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '4B AJAX - START' );
        var meta = { 'section_4b_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '4B AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_4b_data );
    },
    
    resetProcess() {
        // Reset fields, enable / disable UI elements etc...
    },
    
    load4AOverheadsData() {
        /*
         * Get Monthly Overheads Total Data from Section 4A.
         * 
         */
        
        // Load JSON data from text field linked to backend...
        if ( $( '#section_4a_data_field' ).length > 0 && $( '#section_4a_data_field' ).val() != '' ) {
            var aon_section_4a_data_json = $( '#section_4a_data_field' ).val();
            this.aon_section_4a_data = JSON.parse( aon_section_4a_data_json );
        }

        //s4_a_annual_overheads_form_rent_etc
        $.each( this.aon_section_4a_data, function( index ) {
            // Loop over data entries...   
            $( '#s4_a_monthly_overheads_form_rent_etc' ).val( this.s4_a_monthly_overheads_form_rent_etc );
            $( '.s4_b_table_monthly_overheads_form_rent_etc td input' ).val( this.s4_a_monthly_overheads_form_rent_etc );
            
            $( '#s4_a_monthly_overheads_form_property_etc' ).val( this.s4_a_monthly_overheads_form_property_etc );
            $( '.s4_b_table_monthly_overheads_form_property_etc td input' ).val( this.s4_a_monthly_overheads_form_property_etc );
            
            $( '#s4_a_monthly_overheads_form_phone_etc' ).val( this.s4_a_monthly_overheads_form_phone_etc );
            $( '.s4_b_table_monthly_overheads_form_phone_etc td input' ).val( this.s4_a_monthly_overheads_form_phone_etc );
            
            $( '#s4_a_monthly_overheads_form_bank_etc' ).val( this.s4_a_monthly_overheads_form_bank_etc );
            $( '.s4_b_table_monthly_overheads_form_bank_etc td input' ).val( this.s4_a_monthly_overheads_form_bank_etc );
            
            $( '#s4_a_monthly_overheads_form_car_etc' ).val( this.s4_a_monthly_overheads_form_car_etc );
            $( '.s4_b_table_monthly_overheads_form_car_etc td input' ).val( this.s4_a_monthly_overheads_form_car_etc );
            
            $( '#s4_a_monthly_overheads_form_accountancy_etc' ).val( this.s4_a_monthly_overheads_form_accountancy_etc );
            $( '.s4_b_table_monthly_overheads_form_accountancy_etc td input' ).val( this.s4_a_monthly_overheads_form_accountancy_etc );
            
            $( '#s4_a_monthly_overheads_form_wages_etc' ).val( this.s4_a_monthly_overheads_form_wages_etc );
            $( '.s4_b_table_monthly_overheads_form_wages_etc td input' ).val( this.s4_a_monthly_overheads_form_wages_etc );
            
            $( '#s4_a_monthly_overheads_form_other' ).val( this.s4_a_monthly_overheads_form_other );
            $( '.s4_b_table_monthly_overheads_form_other td input' ).val( this.s4_a_monthly_overheads_form_other );
            
            $( '#s4_a_monthly_overheads_form_total' ).text( this.s4_a_monthly_overheads_form_total );
            $( '.s4_b_table_monthly_overheads_total' ).text( this.s4_a_monthly_overheads_form_total );

            $( '#s4_a_annual_overheads_form_rent_etc' ).val( this.s4_a_annual_overheads_form_rent_etc );
            
            $( '#s4_a_annual_overheads_form_property_etc' ).val( this.s4_a_annual_overheads_form_property_etc );
            
            $( '#s4_a_annual_overheads_form_phone_etc' ).val( this.s4_a_annual_overheads_form_phone_etc );
            
            $( '#s4_a_annual_overheads_form_bank_etc' ).val( this.s4_a_annual_overheads_form_bank_etc );
            
            $( '#s4_a_annual_overheads_form_car_etc' ).val( this.s4_a_annual_overheads_form_car_etc );
            
            $( '#s4_a_annual_overheads_form_accountancy_etc' ).val( this.s4_a_annual_overheads_form_accountancy_etc );
            
            $( '#s4_a_annual_overheads_form_wages_etc' ).val( this.s4_a_annual_overheads_form_wages_etc );
            
            $( '#s4_a_annual_overheads_form_other' ).val( this.s4_a_annual_overheads_form_other );
            
            $( '#s4_a_annual_overheads_form_total' ).text( this.s4_a_annual_overheads_form_total );
        });
        console.log( 'this.aon_section_4a_data array:' );
        console.table( this.aon_section_4a_data );

    }

}